<template>
  <div class="f-column">
    <div class="subcription-section">
      <div class="subcription-section_inner f-column">
        <div
          class="f-column text-big f-center weight_700 text-center"
          :class="{ 'no-events': isStarter }"
        >
          <div>
            {{ $t('subscription.selected_game_plan') }}
          </div>

          <div class="d-flex flex-wrasp f-center clr-primary">
            <div>
              <span class="selected-tier selected-tier_no-after text-nowrap ma-0">
                {{ $t(`gametypes.groups.${gm_type}_long`) }} /
              </span>
            </div>

            <GwMenu
              ref="gwmenu"
              trigger="hover"
              placement="bottom"
              :flOptions="{ offset: 0 }"
            >
              <template #opener>
                <div class="text-nowrap">
                  <span
                    class="selected-tier text-nowrap"
                    :class="[{ 'move-left': !isStarter }, { 'selected-tier_no-after': isStarter }]"
                  >
                    {{ $t(`tier.options.${gm_tier}`) }}
                  </span>
                  <span
                    v-if="!isStarter && !gmStraddle"
                    class="mdi mdi-menu-down"
                    style="font-size: 24px"
                  ></span>
                </div>
              </template>
              <v-list>
                <v-list-item
                  v-for="id in ['starter', 'premium', 'elite'].filter(i =>
                    gmStraddle ? i !== gm_tier && i !== 'starter' : i !== gm_tier,
                  )"
                  :key="id + 'f'"
                  @click="setQuery({ gm_tier: id })"
                >
                  <div class="tier-item">
                    {{ $t(`tier.options.${id}`) }}
                  </div>
                </v-list-item>
              </v-list>
            </GwMenu>
          </div>
        </div>
        <div class="payment-boxes mx-auto mt-4">
          <AffiliateMessage
            v-if="anyCheapPlan.discount"
            class="mx-auto mb-4 mx-auto"
            :cheapPlan="anyCheapPlan"
          />
          <PaymentSelectionBox
            v-for="option in selectedTierPlans"
            :id="option.id"
            :key="option.title"
            class="mb-4 elevation-4 mx-auto"
            :title="option.title"
            :price="option.month_price"
            :priceNoDiscount="option.no_discount_month_price"
            :subtitle="option.subtitle"
            :option
            :discountEligible="option.affiliate"
            :nextMonthPrice="option.next_month_price"
            :nextYearPrice="option.next_year_price"
            :tagText="
              option.savings
                ? `${$t(`tags.save_up_to`, {
                    amount: option.savings,
                  })}`
                : ''
            "
            @click="choosePlan(option)"
          />
        </div>
      </div>
    </div>

    <TestimonialSlideshow :items="testimonials" />
  </div>
</template>

<script>
import { nextTick } from 'vue'
import PaymentSelectionBox from '@/components/Payments/PaymentSelectionBox'
import TestimonialSlideshow from '@/components/lib/Slideshow/TestimonialSlideshow'
import AffiliateMessage from '@/components/Payments/AffiliateMessage'
import GwMenu from '@/components/lib/GwMenu'
import { seg_track, seg_getProduct, seg_getTotalAndCurrency } from '@/helpers/segment'
import { gtm_sub_purchase_01 } from '@/helpers/gtm'

import format_mix from '@/mixins/format_mix'
import payment_mix from '@/mixins/payment_mix'

export default {
  name: 'SubscriptionPaymentSelection',
  components: {
    PaymentSelectionBox,
    TestimonialSlideshow,
    AffiliateMessage,
    GwMenu,
  },
  mixins: [format_mix, payment_mix],
  data() {
    return {}
  },
  mounted() {
    nextTick(() => {
      const products = this.selectedTierPlans.map(plan =>
        seg_getProduct({
          plan: plan.plan,
          price: { price: plan?.plan?.price },
        }),
      )
      seg_track('checkout_step_viewed', {
        step: 1,
        checkout_type: 'Purchase Funnel',
        // currency: 'USD',
        ...seg_getTotalAndCurrency(products),
        products,
      })
    })
  },
  methods: {
    choosePlan(option) {
      const { plan } = option
      const product = {
        plan,
        price: { price: plan?.price },
      }
      gtm_sub_purchase_01({
        currencyCode: 'USD',
        game: plan.type,
        type: plan.tier.toLowerCase(),
        paymentType: plan.interval.toLowerCase(),
        price: plan.price,
      })
      seg_track('checkout_step_completed', {
        step: 1,
        checkout_type: 'Purchase Funnel',
        // currency: 'USD',
        ...seg_getTotalAndCurrency([product]),
        products: [
          {
            // quantity: 1,
            ...seg_getProduct(product),
          },
        ],
      })
      this.$router
        .push({
          name: 'SubscriptionPaymentGate',
          query: {
            gm_type: plan.type.toLowerCase(),
            gm_tier: plan.tier.toLowerCase(),
            gm_interval: plan.interval.toLowerCase(),
          },
        })
        .catch(() => {})
    },
    setQuery(q) {
      this.$router
        .replace({
          query: {
            ...this.$route.query,
            ...q,
          },
        })
        .catch(() => {})
    },
  },
  computed: {
    isStarter() {
      return this.currentSub?.plan?.tier.toLowerCase() === 'starter'
    },
    testimonials() {
      const opts = {
        cash: [
          { id: 'three', img: 'SauloCosta_avatar.webp' },
          { id: 'one', img: 'discord_avatar.webp' },
          { id: 'two', img: 'avatar_1.webp' },
        ],
      }
      let res = opts.cash
      res = res.map(i => ({
        ...i,
        name: this.$t(`subscription.testimonial.${i.id}.person`),
        bio: this.$t(`subscription.testimonial.${i.id}.bio`),
        text: this.$t(`subscription.testimonial.${i.id}.text`),
      }))
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.selected-tier {
  text-transform: capitalize;
  color: var(--clr-primary);
  margin: 0 0 0 0.5rem;
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 2px;
    background: var(--clr-primary);
    position: absolute;
    left: 0;
    bottom: 0;
  }
  &_no-after {
    &:after {
      display: none;
    }
  }
}
.move-left {
  &:after {
    left: -3px !important;
  }
}
.tier-item {
  font-size: 1rem;
  text-transform: capitalize;
  font-weight: 700;
}
.slideshow-circle {
  border-radius: 50%;
  background: var(--clr-black-3);
  height: 0.7rem;
  width: 0.7rem;
  margin: 0 0.25rem;
  transition: 0.3s;
  cursor: pointer;
  &:hover {
    background: var(--clr-grey-2);
  }
  &_active {
    background: var(--clr-grey-2);
  }
}
</style>
